import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, change } from 'redux-form';
import Checkbox from '@material-ui/core/Checkbox';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { RenderIfToggleOn, RenderIfToggleOff } from 'components/shared/ToggleRenderer';

const FORM_NAME = 'new_tenant_ticket_form';

const StyledTitle = styled.h4`
  margin: 0;
  padding-bottom: 5px;
  margin-left: 2px;
`;

const StyledText = styled.p`
  text-align: left;
  white-space: pre-line;
  padding-bottom: 10px;
  margin-left: 2px;
`;

const StyledTextWithCheckbox = styled(StyledText)`
  padding-bottom: 3px;
  margin-bottom: 0;
`;

const StyledCheckbox = styled(Checkbox)`
  padding: 0;
  margin-right: 8px;
`;

const StyledLabelGroup = styled.div`
  padding-bottom: 20px;
`;

const StyledLabel = styled.p`
  display: inline;
  top: 1px;
  position: relative;
`;

const ConsentToNoticeOfEntry = ({ change, onSubmit }) => {
  const [permissionToEnter, setPermissionToEnter] = useState(false);
  const [consentToEntryWhileAway, setConsentToEntryWhileAway] = useState(false);

  const handleSetPermissionToEnter = () => {
    setPermissionToEnter(!permissionToEnter);
    change('permission_to_enter', !permissionToEnter);
  };

  const handleSetConsentToEntryWhileAway = () => {
    setConsentToEntryWhileAway(!consentToEntryWhileAway);
    change('consent_to_entry_while_away', !consentToEntryWhileAway);
  };

  return (
    <form onSubmit={onSubmit}>
      <RenderIfToggleOn toggle="ui.residents.create_service_request.notice_of_entry_consent.permission_to_enter_non_24hour">
        <PermissionToEnter
          value={permissionToEnter.toString()}
          checked={permissionToEnter}
          onClick={handleSetPermissionToEnter}
        />
      </RenderIfToggleOn>
      <RenderIfToggleOff toggle="ui.residents.create_service_request.notice_of_entry_consent.permission_to_enter_non_24hour">
        <PermissionToEnterWith24HourNotice
          value={permissionToEnter.toString()}
          checked={permissionToEnter}
          onClick={handleSetPermissionToEnter}
        />
      </RenderIfToggleOff>
      <RenderIfToggleOn toggle="ui.create_service_request.consent_to_entry_while_away">
        <ConsentToEntryWhileAway
          value={consentToEntryWhileAway.toString()}
          checked={consentToEntryWhileAway}
          onClick={handleSetConsentToEntryWhileAway}
        />
      </RenderIfToggleOn>
    </form>
  );
};

export default compose(connect(null, { change }), reduxForm({ form: FORM_NAME }))(
  ConsentToNoticeOfEntry
);

const PermissionToEnter = ({ value, checked, onClick }) => {
  return (
    <Fragment>
      <StyledTitle>
        {getTranslatedString('residentPortal.serviceRequest.consentTitlePermissionToEnter')}
      </StyledTitle>
      <StyledText>
        {getTranslatedString('residentPortal.serviceRequest.consentBodyPermissionToEnter')}
      </StyledText>

      <StyledLabelGroup>
        <StyledCheckbox
          name="permission_to_enter"
          value={value}
          checked={checked}
          onClick={onClick}
        />
        <StyledLabel>
          {getTranslatedString('residentPortal.serviceRequest.consentCheckboxPermissionToEnter')}
        </StyledLabel>
      </StyledLabelGroup>
    </Fragment>
  );
};

const PermissionToEnterWith24HourNotice = ({ value, checked, onClick }) => {
  return (
    <Fragment>
      <StyledTitle>
        {getTranslatedString('residentPortal.serviceRequest.consentTitle24hNotice')}
      </StyledTitle>
      <StyledText>
        {getTranslatedString('residentPortal.serviceRequest.consentBody24hNotice')}
      </StyledText>

      <StyledTitle>
        {getTranslatedString('residentPortal.serviceRequest.consentTitleLessThan24h')}
      </StyledTitle>
      <StyledTextWithCheckbox>
        {getTranslatedString('residentPortal.serviceRequest.consentBodyLessThan24h')}
      </StyledTextWithCheckbox>
      <StyledLabelGroup>
        <StyledCheckbox
          name="permission_to_enter"
          value={value}
          checked={checked}
          onClick={onClick}
        />
        <StyledLabel>{getTranslatedString('iConsent')}</StyledLabel>
      </StyledLabelGroup>
    </Fragment>
  );
};

const ConsentToEntryWhileAway = ({ value, checked, onClick }) => {
  return (
    <Fragment>
      <StyledTitle>
        {getTranslatedString('residentPortal.serviceRequest.consentTitleNotHome')}
      </StyledTitle>
      <StyledTextWithCheckbox>
        {getTranslatedString('residentPortal.serviceRequest.consentBodyNotHome')}
      </StyledTextWithCheckbox>
      <StyledLabelGroup>
        <StyledCheckbox
          name="consent_to_entry_while_away"
          value={value}
          checked={checked}
          onClick={onClick}
        />
        <StyledLabel>
          {getTranslatedString('residentPortal.serviceRequest.iConsentWhenNotHome')}
        </StyledLabel>
      </StyledLabelGroup>
    </Fragment>
  );
};
